export const selectedIcons = [
  'cart',
  'cash',
  'checkbox-marked',
  'coffee',
  'credit-card',
  'home',
  'phone',
  'piggy-bank',
  'sticker',
  'tag',
  'tag-multiple',
]

export const selectedOutlineIcons = [
  'cart-outline',
  'cash-100',
  'checkbox-marked-outline',
  'coffee-outline',
  'credit-card-outline',
  'home-outline',
  'phone-outline',
  'piggy-bank-outline',
  'sticker-outline',
  'tag-outline',
  'tag-multiple-outline',
]
